import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { CustomHighlight } from '../../types';
import type { CustomHighlightModel } from '../custom-highlight-model';

@injectable()
export class CustomHighlightModelImpl extends AbstractModel<CustomHighlight> implements CustomHighlightModel {
    protected _modelData: CustomHighlight = {
        isEnable: false,
    };
}
